/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FaChevronRight } from "react-icons/fa";
import { PiSealCheck } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProfileInfo from "../../components/common/ProfileInfo";
import ShowDocument from "../../components/common/ShowDocument";
import AddProviderDoc from "../../components/modal/AddProviderDoc";
import RejectProviderDoc from "../../components/modal/RejectProviderDoc";
import { getApiCaller } from "../../libs/apiCaller";

const ProfileReview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const providerFromState = location.state?.provider; // Provider from navigation state
  const [provider, setProvider] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [openDocModal, setOpenDocModal] = useState(false);
  const [rejectOpenModal, setRejectOpenModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("Documents Incomplete");
  const [otherReason, setOtherReason] = useState("");
  const [changeDocumentData, setChangeDocumentData] = useState({});

  // Fetch provider details from API
  const fetchProviderDetails = async () => {
    setLoading(true);
    if (!providerFromState?.id) {
      setError("Provider ID not found!");
      setLoading(false);
      return;
    }

    try {
      const response = await getApiCaller(
        `provider_details?provider_id=${providerFromState.id}`
      );
      setProvider(response.data.response_data);
    } catch (error) {
      setError("Failed to fetch provider details.");
      toast.error("Error fetching provider details!");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchProviderDetails();
  }, [providerFromState]);

  // Redirect back to pending requests list
  const handleBack = () => {
    navigate("/PendingRegistration");
  };

  // Handle API call for Approve/Reject
  const handleAction = async (type) => {
    if (!provider?.id) {
      toast.error("Provider ID not found!");
      return;
    }

    // Show alert before rejecting
    if (type === "Reject") {
      try {
        const formData = new FormData();
        const selectedReasonData =
          selectedReason === "Other" ? otherReason : selectedReason;
        formData.append("provider_id", provider.id);
        formData.append("reject_reason", selectedReasonData);

        await getApiCaller(
          `provider_reject?provider_id=${provider.id}&reject_reason=${selectedReasonData}`
        );
        toast.success(`Provider ${type} successfully!`);
        navigate("/PendingRegistration"); // Redirect after successful action
      } catch (error) {
        toast.error(
          `Failed to ${type.toLowerCase()} provider. Please try again.`
        );
      }
    }

    if (type !== "Reject") {
      try {
        const formData = new FormData();
        formData.append("id", provider.id);
        formData.append("type", type);

        await getApiCaller(`provider_approve?provider_id=${provider.id}`);
        toast.success(`Provider ${type} successfully!`);
        navigate("/PendingRegistration"); // Redirect after successful action
      } catch (error) {
        toast.error(
          `Failed to ${type.toLowerCase()} provider. Please try again.`
        );
      }
    }
  };

  return (
    <>
      <div className="px-4 md:px-10">
        {/* Breadcrumb */}
        <div className="flex flex-col sm:flex-row mt-6 gap-2 items-start sm:items-center justify-between">
          <div className="flex text-sm gap-2 items-center">
            <button
              onClick={handleBack}
              className="text-[#284184] text-sm sm:text-xl hover:underline"
            >
              All Providers
            </button>
            <FaChevronRight className="text-[#284184] text-md" />
            <span className="text-[#284184] text-sm sm:text-xl">Requests</span>
            <FaChevronRight className="text-[#284184] text-md" />
            <span className="text-[#284184] text-sm sm:text-xl font-bold">
              {provider
                ? `${provider.first_name} ${provider.last_name}`
                : "Provider Name"}
            </span>
          </div>
          <div className="flex gap-3">
            <button
              className="bg-[#FEE4E2] text-[#F04438] px-4 py-2 rounded-md"
              onClick={() => setRejectOpenModal(true)}
            >
              Reject
            </button>
            <button
              className="bg-[#00A651] text-white px-4 py-2 rounded-md"
              onClick={() => handleAction("Approved")}
            >
              <span className="flex items-center gap-1">
                <PiSealCheck className="text-xl" />
                Approve
              </span>
            </button>
          </div>
        </div>
        {loading ? (
          <div className="text-center flex items-center justify-center my-10 h-[70vh]">
            <PropagateLoader color="#284184" loading={true} size={10} />
          </div>
        ) : error ? (
          <p className="text-center text-red-500 my-4">{error}</p>
        ) : (
          <>
            <ProfileInfo provider={provider} />
            <ShowDocument
              provider={provider}
              setOpenDocModal={setOpenDocModal}
              documents={provider.document_list}
              documentExpireDate={provider?.doc_expiry_date}
              setChangeDocumentData={setChangeDocumentData}
              changeDocumentData={changeDocumentData}
            />
          </>
        )}
      </div>
      <AddProviderDoc
        isOpen={openDocModal}
        onClose={() => setOpenDocModal(false)}
        changeDocumentData={changeDocumentData}
        setChangeDocumentData={setChangeDocumentData}
        provider={provider}
        fetchProviderProfileDetails={fetchProviderDetails}
      />
      <RejectProviderDoc
        isOpen={rejectOpenModal}
        onClose={() => setRejectOpenModal(false)}
        setSelectedReason={setSelectedReason}
        setOtherReason={setOtherReason}
        selectedReason={selectedReason}
        otherReason={otherReason}
        handleAction={() => handleAction("Reject")}
      />
    </>
  );
};

export default ProfileReview;
